# How a clientAPI call's FIRST argument is split into path and body params.
#
# Lives here, as a plain CommonJS module, for two reasons: client_api.coffee is
# ESM at module scope (so it cannot be required by a test harness), and this
# split is the contract the SERVER depends on — bootstrap's socket dispatch
# rebuilds the positional argument vector from pathParams/postParams BY NAME.
# A key that neither side agrees to carry is not an error anywhere; the
# argument simply arrives undefined.
#
# Isomorphic by construction: no DOM, no node built-ins (framework/shared/).

# The declared non-path arguments a caller passed inside the FIRST object.
#
# A method that mixes a path param with body params — shareDocument(id, grant)
# — is naturally called as one object: shareDocument({id, grant}). Only the
# path key used to be read out of it, so `grant` was dropped and the server
# rejected the call as if the caller had sent garbage. Restricted to DECLARED
# parameter names so an incidental key on the caller's object can never become
# an argument.
bodyParamsFromFirstArg = (parameters, param1) ->
  out = {}
  return out unless param1? and typeof param1 == 'object' and not Array.isArray(param1)
  for spec in (parameters or []) when spec?.name? and spec.in != 'path'
    out[spec.name] = param1[spec.name] if spec.name of param1
  out

# What a GET call's SECOND argument serialises to as query parameters.
#
# The HTTP transport used to dump that argument wholesale under
# `?filter=<json>` whenever the method had a path param, regardless of what the
# method DECLARES. That is right for the relation and list readers whose
# declared non-path argument really IS `filter`, and wrong for every method
# that declares named arguments — Committable.diff({id}, {commitId}),
# Commit.diffToCommit({id}, {otherCommitId}), searchField, AIHints. There the
# argument arrived as `?filter={"commitId":"…"}`, `commitId` was never in
# req.query, and the server refused the call for a missing required argument
# the caller demonstrably supplied (card 6a6d34ecd3bc5a01f6ed7abf).
#
# The test is the one httpCall's own no-path-params GET branch already uses,
# lifted here so both branches decide the same way: if the object names any
# DECLARED non-path parameter it is NAMED ARGS and each key travels under its
# own name; otherwise it is a filter spec and the legacy shape is preserved.
# That keeps `filter` working for the callers that depend on it, including the
# explicit `{filter: …}` form, which the old code wrapped a second time.
#
# Returns a plain {name: value} map for the caller to serialise; percent- and
# JSON-encoding are the transport's business, not this module's.
queryParamsFromRestArg = (parameters, restArg) ->
  return {} unless restArg? and typeof restArg == 'object' and not Array.isArray(restArg)
  declared = (spec for spec in (parameters or []) when spec?.name? and spec.in != 'path')
  named = (spec for spec in declared when spec.name of restArg)
  return {filter: restArg} unless named.length
  out = {}
  out[spec.name] = restArg[spec.name] for spec in named
  out

module.exports = {bodyParamsFromFirstArg, queryParamsFromRestArg}
